import { removeBoundSlash } from 'utils/shared/strings/removeBoundSlash';

interface BuildApiRequestEndpointArgs {
  /** Gateway base, e.g. `${API_ROOT}/api`. */
  baseUrl?: string;
  /** The hook-level endpoint, e.g. `/v1/products/option-flow/count`. */
  endpointPrefix?: string;
  /** The per-request endpoint: a path segment (`AAPL`) or a query string (`?foo=bar`). */
  fetchEndpoint?: string;
}

/**
 * Joins the API base URL, the hook's endpoint prefix, and a per-request endpoint
 * into a single request URL.
 *
 * Query-string-only endpoints (e.g. `?foo=bar`) attach directly to the prefix.
 * Joining them with `/` would yield `.../path/?foo=bar`, which the gateway
 * 308-redirects to the slashless URL — an extra round trip on every poll.
 */
export const buildApiRequestEndpoint = ({
  baseUrl = '',
  endpointPrefix = '',
  fetchEndpoint = '',
}: BuildApiRequestEndpointArgs): string => {
  const normalizedFetchEndpoint = removeBoundSlash(fetchEndpoint);

  const endpoint = normalizedFetchEndpoint.startsWith('?')
    ? `${endpointPrefix}${normalizedFetchEndpoint}`
    : `${endpointPrefix}/${normalizedFetchEndpoint}`;

  const requestEndpoint = removeBoundSlash(endpoint);

  return `${baseUrl}/${requestEndpoint}`;
};
